import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "20px",
	height: "20px",
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "022F4369-9609-45AF-A05E-956EDFDE4FEA" }), /* @__PURE__ */ _jsx("g", {
		id: "UI-Toolkit",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Onboard-Alerts-and-Pills",
			transform: "translate(-881.000000, -447.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group-Copy-2",
				transform: "translate(861.000000, 437.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group",
					transform: "translate(20.000000, 10.000000)",
					children: [/* @__PURE__ */ _jsx("circle", {
						id: "Circle-Copy",
						fill: "#004C6C",
						cx: 10,
						cy: 10,
						r: 10
					}), /* @__PURE__ */ _jsx("path", {
						d: "M10.2804235,8.75001609 L9.61245639,8.75001609 C9.32107906,8.75001609 9.08113136,8.97266037 9.05277297,9.25662194 L8.60278091,13.7566112 C8.60092697,13.7751849 8.6,13.7940333 8.6,13.8130877 C8.6,14.1230387 8.85127732,14.374213 9.16105671,14.3750027 L10.7304499,14.3750027 C11.0408816,14.3750027 11.2929143,14.1229357 11.2929143,13.812504 C11.2929143,13.7934497 11.2919873,13.7751849 11.2901334,13.7566112 L10.8401413,9.25662194 C10.8117829,8.97266037 10.5718352,8.75001609 10.2804235,8.75001609 Z M9.94575332,7.74999464 C9.3248556,7.74999464 8.820756,7.24589504 8.820756,6.62499732 C8.820756,6.0040996 9.3248556,5.5 9.94575332,5.5 C10.566651,5.5 11.0707506,6.0040996 11.0707506,6.62499732 C11.0707506,7.24589504 10.566651,7.74999464 9.94575332,7.74999464 Z",
						id: "\\uDBFC\\uDC6A",
						fill: "#FFFFFF",
						fillRule: "nonzero"
					})]
				})
			})
		})
	})]
});
export default SvgInfo;
